import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';


const firebaseConfig = {
  apiKey: "AIzaSyALZMfRG97llTZDFDTOsxBH1MTcH5d_Za0",
  authDomain: "previsoesoscar.firebaseapp.com",
  projectId: "previsoesoscar",
  storageBucket: "previsoesoscar.firebasestorage.app",
  messagingSenderId: "955101287557",
  appId: "1:955101287557:web:d9377856eea7606f9745ec"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app); // ← aqui está o que faltava

export { auth, db, storage }; // ← agora o storage é exportado corretamente